module.exports = __webpack_public_path__ + "static/media/left-hand.7b6efa56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/GetAShareResources/left-hand.svg
// module id = 180
// module chunks = 0